import React from "react";
import styled, { keyframes } from "styled-components";
import HeroSection from "../components/HeroSection";
// import TechnologyIcons from "../components/TechnologyIcons"; // Optional to keep or remove
import Mission from "../components/Mission";
// import SkillsChart from "../components/SkillsChart"; // Optional to keep or remove
import Projects from "../components/Projects";
import Work from "../components/Work";
import Education from "../components/Education";
import Partners from "../components/Partners";
import {
  FadeInSection,
  SlideInSection,
  ScaleInSection,
} from "../components/AnimationComponents";

const HomeContainer = styled.div`
  position: relative;
  background: transparent;
`;

const lightSweep = keyframes`
  0% { background-position: 0% 0%, -100% 0; }
  100% { background-position: 0% 0%, 200% 0; }
`;

const SectionSpacer = styled.div`
  height: 4rem;
  background: transparent;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 10%;
    right: 10%;
    height: 1px;
    background: 
      linear-gradient(90deg, transparent, rgba(255,255,255,0.08) 10%, rgba(255,255,255,0.08) 90%, transparent),
      linear-gradient(90deg, transparent, rgba(74, 144, 226, 0) 20%, rgba(144, 19, 254, 1) 50%, rgba(74, 144, 226, 0) 80%, transparent);
    background-size: 100% 100%, 40% 100%;
    background-repeat: no-repeat;
    animation: ${lightSweep} 4s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }
`;

const Home = () => {
  return (
    <HomeContainer>
      <FadeInSection>
        <HeroSection />
      </FadeInSection>

      <FadeInSection>
        <Partners />
      </FadeInSection>

      <SlideInSection>
        <Mission id="mission" />
      </SlideInSection>

      <SectionSpacer />

      <FadeInSection>
        <Work />
      </FadeInSection>

      <SectionSpacer />

      <SlideInSection delay={200}>
        <Education />
      </SlideInSection>

      <SectionSpacer />

      <Projects />

      <SectionSpacer />

    </HomeContainer>
  );
};

export default Home;
